module.exports = __webpack_public_path__ + "img/featured-desktop-cta-3.1c9ec513.jpg";